import React, { useCallback, useEffect, useState } from 'react';
import { executionTableHeaders } from '../../test-case/testCaseTableHead';
import TableComponent from '../../../../ui/data/table/TableComponent';
import { getDateAndTime } from '../../../../lib/utils';
import { useNotification } from '../../../../hooks/NotificationContext';
import { getTestCaseExecutions } from '../../../../modules/executions';
import { useParams } from 'react-router-dom';
import { showUserDisplayName } from '../../../../lib/userUtils';
import DetailsCard from '../../../../ui/layout/DetailsCard'
const TestCaseExecutionTable = ({ testCaseId, users, testCaseKey }) => {
  const [testExecutions, setTextExecutions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState('asc');
  const { addNotification } = useNotification();
  const { projectId } = useParams();
  const fetchTestCaseData = async () => {
    setLoading(true);
    try {
      const response = await getTestCaseExecutions(testCaseId);
      setTextExecutions(response?.data);
    } catch (error) {
      const errorMessage = error?.message || 'Failed to fetch executions.';
      addNotification('danger', errorMessage);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (testCaseId) {
      fetchTestCaseData();
    }
  }, [testCaseId]);

  const formData = () => {
    return (
      testExecutions &&
      testExecutions.map((exe) => ({
        key: exe?.key,
        id: exe?.id,
        status: exe?.status,
        environment: exe?.iteration?.environment_details?.name || 'None',
        iteration: exe?.iteration?.name || 'None',
        testCycleKey: exe?.testcycle?.key,
        testCycleId: exe?.testcycle?.id,
        testCaseId: exe?.association?.testcase?.id,
        testCaseKey: testCaseKey,
        associatedTestCaseId: exe?.association?.id,
        jiraIssueDetails: exe?.jira_issue_details || [],
        executedBy: showUserDisplayName(exe?.executed_by, users),
        actualTime: exe?.actual_time,
        executionTime: getDateAndTime(exe?.updated_at),
        projectId,
      }))
    );
  };
  const formattedData = useCallback(() => {
    return formData();
  }, [testCaseId, testExecutions]);

  const finalData = formattedData();
  return (
    <DetailsCard title="Test Case Execution">
      <TableComponent
        data={finalData || []}
        headerTabs={executionTableHeaders}
        isLoading={loading}
        page={0}
        striped
        perPage={10}
        selected={selected}
        setSelected={setSelected}
        showCheckbox={false}
        order={order}
        setOrder={setOrder}
      />
    </DetailsCard>
  );
};

export default TestCaseExecutionTable;
